__turbopack_context__.v({
  "header": "styles-module-scss-module__DVtOla__header",
});
